const VuePlyr = require('vue-plyr/dist/vue-plyr.cjs').VuePlyr
require('plyr/dist/plyr.css')
require('./plyr.css')

VuePlyr.install = Vue => Vue.component(VuePlyr.name, VuePlyr)

module.exports = VuePlyr
